import { message } from "antd";
import axios from "axios";

const SECONDS = 30;
const MILISECONDS = 1000;
const TIMEOUT = SECONDS * MILISECONDS;
const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;

const MultipartUploadClient = axios.create({
    baseURL: REACT_APP_BASE_API,
    timeout: TIMEOUT,
    headers: {
        "content-type": "multipart/form-data",
    }
});

MultipartUploadClient.interceptors.request.use(config => {
    const jwtToken = localStorage.getItem("token")
    if (jwtToken) {
        config.headers["authorization"] = 'Bearer ' + jwtToken
    }
    if (!jwtToken && !config.headers["public-request"]) {
    }
    return config
}, error => {
    return Promise.reject(error)
})

MultipartUploadClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.data) {
            message.error(error?.response?.data?.message);
        }
        return Promise.reject(error);
    }
);

export default MultipartUploadClient;